import { useCallback } from 'react';

/**
 * useLeaderResources - Custom Hook for managing resources (workers, vehicles, teams).
 * Encapsulates navigation to specialized management tools and modal states.
 */
export const useLeaderResources = ({
    // State Setters
    setEditingKolonneId,
    setKolonnenManagementOpen,
    setFocusResource,
    setConflictOverviewOpen,

    // UI State / Context
    conflictExpandedResources,
    conflictCollapsedSections,
    navigate
}) => {

    /**
     * Navigates to the employee management (EmployeeTool) and passes context state.
     */
    const handleOpenWorkerModal = useCallback((id, action) => {
        const state = { 
            from: '/tools/leader',
            conflictState: {
                expandedResources: Array.from(conflictExpandedResources),
                collapsedSections: Array.from(conflictCollapsedSections)
            }
        };
        if (id) state.openWorkerId = id;
        if (action) state.targetTab = action === 'absences' ? 'calendar' : action;
        navigate('/verwaltung/mitarbeiter', { state });
    }, [conflictExpandedResources, conflictCollapsedSections, navigate]);

    /**
     * Opens the team (kolonnen) management modal.
     */
    const handleOpenKolonnenManagement = useCallback((editId = null) => {
        setEditingKolonneId(editId);
        setKolonnenManagementOpen(true);
    }, [setEditingKolonneId, setKolonnenManagementOpen]);

    /**
     * Opens the conflict center with optional focus on a specific resource.
     */
    const handleOpenConflictOverview = useCallback((resInfo = null) => {
        setFocusResource(resInfo);
        setConflictOverviewOpen(true);
    }, [setFocusResource, setConflictOverviewOpen]);

    return {
        handleOpenWorkerModal,
        handleOpenKolonnenManagement,
        handleOpenConflictOverview
    };
};
